import React from 'react';
import { 
  FaChartLine, FaBell, FaSyncAlt, FaUsers, 
  FaFileInvoice, FaCheckCircle, FaPlayCircle 
} from 'react-icons/fa';
import './BizAnalyst.css';
import PlansAndPricing from './PlansAndPricing';

const BizAnalyst = () => {
  return (
    <div className="biz-analyst-wrapper">
      {/* ── Hero Section ── */}
      <header className="biz-hero">
        <div className="biz-hero-main">
          <div className="biz-hero-content">
            <h1>Biz Analyst for Tally</h1>
            <p>
              The leading mobile app for Tally users. Access real-time data, 
              analyze business performance, and make data-driven decisions 
              on the go—securely synced with your TallyPrime installation.
            </p>
          </div>
          <div className="biz-hero-visual">
            <img src="/images/tally-biz.png" alt="Biz Analyst Mobile App" className="biz-hero-img" />
          </div>
        </div>
      </header>

      {/* ── Feature Grid Section ── */}
      <section className="biz-features-section">
        <div className="features-header">
          <h2>Why Choose Biz Analyst?</h2>
        </div>
        <div className="biz-grid">
          <FeatureCard 
            icon={<FaChartLine />}
            title="Analyse & Grow Sales"
            points={[
              "Analyse sales by location, stock item, or month",
              "Identify and follow up with inactive customers",
              "Detailed customer-level sales insights",
              "Strategic upselling opportunities"
            ]}
          />
          <FeatureCard 
            icon={<FaBell />}
            title="Faster Payment Recovery"
            points={[
              "Send multiple reminders with a single click",
              "Share via WhatsApp, Email, or SMS instantly",
              "Reduce payment delays by up to 50%",
              "Optimize and protect your cash flow"
            ]}
          />
          <FeatureCard 
            icon={<FaSyncAlt />}
            title="Stay Connected Always"
            points={[
              "No dependency on accountants for reports",
              "Track your business performance 24/7",
              "Real-time data synchronization",
              "Make smart, data-driven decisions anywhere"
            ]}
          />
          <FeatureCard 
            icon={<FaUsers />}
            title="Sales Team Productivity"
            points={[
              "Geo-tagged customer visit reports",
              "Real-time sales order and receipt creation",
              "In-app visit comments and tracking",
              "Granular team access management"
            ]}
          />
          <FeatureCard 
            icon={<FaFileInvoice />}
            title="Mobile Data Entry"
            points={[
              "Create Invoices and Orders from the app",
              "Manage Purchases and Payments on the go",
              "Automatic background sync with Tally",
              "Instant document sharing via WhatsApp"
            ]}
          />
        </div>
      </section>

      {/* ── Pricing Section ── */}
      <PlansAndPricing />

      {/* ── Video Demo Section ── */}
      <section className="biz-video-container">
        <div className="video-title">
          <h2><FaPlayCircle style={{verticalAlign: 'middle', marginRight: '15px'}} /> Watch the Demo</h2>
        </div>
        <div className="video-wrapper">
          <video
            autoPlay
            loop
            muted
            playsInline
            controls
            className="feature-video"
          >
            <source src="/images/video/3.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
    </div>
  );
};

const FeatureCard = ({ icon, title, points }) => {
  return (
    <div className="biz-card">
      <div className="biz-card-icon">{icon}</div>
      <h3>{title}</h3>
      <ul className="biz-card-list">
        {points.map((point, index) => (
          <li key={index} className="biz-card-item">
            <FaCheckCircle />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BizAnalyst;
